import theme from 'styled-theming';
import Themes from './themes';

export const backgroundColor = theme.variants('mode', 'kind', {
  default: {
    light: Themes.light.defaultBackgroundColor,
    dark: Themes.dark.defaultBackgroundColor,
    custom: Themes.custom.defaultBackgroundColor
  },
  primary: {
    light: Themes.light.primaryBackgroundColor,
    dark: Themes.dark.primaryBackgroundColor,
    custom: Themes.custom.primaryBackgroundColor
  },
  secondary: {
    light: Themes.light.secondaryBackgroundColor,
    dark: Themes.dark.secondaryBackgroundColor,
    custom: Themes.custom.secondaryBackgroundColor
  },
  warning: {
    light: Themes.light.warningBackgroundColor,
    dark: Themes.dark.warningBackgroundColor,
    custom: Themes.custom.warningBackgroundColor
  },
  success: {
    light: Themes.light.successBackgroundColor,
    dark: Themes.dark.successBackgroundColor,
    custom: Themes.custom.successBackgroundColor
  },
  info: {
    light: Themes.light.infoBackgroundColor,
    dark: Themes.dark.infoBackgroundColor,
    custom: Themes.custom.infoBackgroundColor
  },
  danger: {
    light: Themes.light.dangerBackgroundColor,
    dark: Themes.dark.dangerBackgroundColor,
    custom: Themes.custom.dangerBackgroundColor
  }
});

export const borderColor = theme.variants('mode', 'kind', {
  default: {
    light: Themes.light.defaultBorderColor,
    dark: Themes.dark.defaultBorderColor,
    custom: Themes.custom.defaultBorderColor
  },
  primary: {
    light: Themes.light.primaryBorderColor,
    dark: Themes.dark.primaryBorderColor,
    custom: Themes.custom.primaryBorderColor
  },
  secondary: {
    light: Themes.light.secondaryBorderColor,
    dark: Themes.dark.secondaryBorderColor,
    custom: Themes.custom.secondaryBorderColor
  },
  warning: {
    light: Themes.light.warningBorderColor,
    dark: Themes.dark.warningBorderColor,
    custom: Themes.custom.warningBorderColor
  },
  success: {
    light: Themes.light.successBorderColor,
    dark: Themes.dark.successBorderColor,
    custom: Themes.custom.successBorderColor
  },
  info: {
    light: Themes.light.infoBorderColor,
    dark: Themes.dark.infoBorderColor,
    custom: Themes.custom.infoBorderColor
  },
  danger: {
    light: Themes.light.dangerBorderColor,
    dark: Themes.dark.dangerBorderColor,
    custom: Themes.custom.dangerBorderColor
  }
});

export const color = theme.variants('mode', 'kind', {
  default: { light: Themes.light.defaultColor, dark: Themes.dark.defaultColor, custom: Themes.custom.defaultColor },
  primary: { light: Themes.light.primaryColor, dark: Themes.dark.primaryColor, custom: Themes.custom.primaryColor  },
  secondary: {
    light: Themes.light.secondaryColor,
    dark: Themes.dark.secondaryColor,
    custom: Themes.custom.secondaryColor
  },
  warning: { light: Themes.light.warningColor, dark: Themes.dark.warningColor, custom: Themes.custom.warningColor },
  success: { light: Themes.light.successColor, dark: Themes.dark.successColor, custom: Themes.custom.successColor },
  info: { light: Themes.light.infoColor, dark: Themes.dark.infoColor, custom: Themes.custom.infoColor },
  danger: { light: Themes.light.dangerColor, dark: Themes.dark.dangerColor, custom: Themes.custom.dangerColor }
});